import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';

import { recurseLangParam } from '@fcom/common/utils/route-utils';
import { ConfigService } from '@fcom/core';

@Injectable()
export class BuyPointsGuard implements CanActivate {
  constructor(
    private configService: ConfigService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const lang = recurseLangParam(route);

    if (!this.configService.cfg.enableBuyPoints) {
      return of(this.deny(lang));
    }

    return of(true);
  }

  private deny(lang: string): false {
    this.router.navigateByUrl(`/${lang}`, { replaceUrl: true });
    return false;
  }
}
